import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { Moment } from 'moment';
import { Case, ClosedPhaseMeta } from 'src/app/models/case';
import { CaseService } from 'src/app/services/case.service';

@Component({
  selector: 'app-case-card',
  templateUrl: './case-card.component.html',
  styleUrls: ['./case-card.component.scss']
})
export class CaseCardComponent {
  @Input() case?: Case;
  @Input() class?: string;
  @Input() withUpload: boolean = false;
  @Input() showState: boolean = false;
  @Input() color: 'white' | 'main' = 'main';
  isSuspended: boolean = true;
  closedMeta?: ClosedPhaseMeta;

  constructor(
    private caseService: CaseService,
    private translate: TranslateService
  ) {

  }


  formatDate(date: string | Moment) {
    return moment(date).format("ll");
  }

}
